<template>
    <div>
      <!--添加告警规则-->
      <el-dialog :visible.sync="updateAlarmRuleDialogVisible" title="修改告警规则" @close="feedBack" v-if="updateAlarmRuleDialogVisible">
        <el-form :label-position="labelPosition" label-width="80px">
          <el-form-item label-width="0">
            <el-row >
              <el-col :span="10">
                <el-select style="width: 90%" placeholder="请选择控制的对象">
                  <el-option>电压</el-option>
                  <el-option>声压</el-option>
                  <el-option>温度</el-option>
                  <el-option>湿度</el-option>
                  <el-option>气体</el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select style="width: 80%">
                  <el-option> > </el-option>
                  <el-option> >= </el-option>
                  <el-option> = </el-option>
                  <el-option> <= </el-option>
                  <el-option> < </el-option>
                </el-select>
              </el-col>
              <el-col :span="10">
                <el-input style="width: 100%" placeholder="请输入控制值"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="告警规则描述">
            <el-input type="textarea" :rows="2" placeholder="请输入告警规则描述"></el-input>
          </el-form-item>


        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="feedBack">取 消</el-button>
          <el-button type="primary" @click="feedBack">确定修改</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  export default {
    name: 'UpdateAlarmRule',
    props:['updateAlarmRuleDialogVisible'],
    data () {
      return {
        labelPosition: 'top',
      }
    },
    methods: {
      feedBack(){
        this.updateAlarmRuleDialogVisible = false;
        this.$emit('feedBack',this.updateAlarmRuleDialogVisible);
      }
    }
  }
</script>

<style scoped>

</style>
